import { getUserDetails } from './helper';

type AutoRefreshSubscriber = (enabled: boolean) => void;

// Roles for which "Auto Sync" defaults ON. These are the report-facing worklist roles
// (radiologist / HOD / typist) where seeing fresh studies matters more than avoiding the
// occasional background refetch. Every other role defaults OFF so refetches don't disrupt
// them mid-action (e.g. technicians in the middle of an order).
const AUTO_SYNC_DEFAULT_ON_ROLES = ['radiologist', 'hod', 'typist'];

const computeRoleDefault = (): boolean => {
  try {
    return AUTO_SYNC_DEFAULT_ON_ROLES.includes(getUserDetails()?.user_type);
  } catch {
    return false;
  }
};

// Auto-refresh / "Auto Sync" is a session-scoped toggle (not persisted). Until the user
// flips the header switch, it reflects the role-based default above; once they flip it,
// their explicit choice (`userOverride`) wins for the rest of the session.
let userOverride: boolean | null = null;
const subscribers = new Set<AutoRefreshSubscriber>();

export const getAutoRefreshEnabled = (): boolean =>
  userOverride !== null ? userOverride : computeRoleDefault();

export const publishAutoRefresh = (enabled: boolean): void => {
  userOverride = enabled;
  subscribers.forEach(callback => {
    try {
      callback(enabled);
    } catch (error) {
      console.error('[autoRefreshPubSub] subscriber error', error);
    }
  });
};

export const subscribeAutoRefresh = (
  callback: AutoRefreshSubscriber,
  emitCurrent = true
): (() => void) => {
  subscribers.add(callback);

  if (emitCurrent) {
    callback(getAutoRefreshEnabled());
  }

  return () => {
    subscribers.delete(callback);
  };
};
